<template>
  <div class="w-100">
    <label for="report-date-range" class="f6 b db mb2">{{ title }}</label>
    <date-range-select v-model="input" bg="dark"/>
    <small if="error" id="report-date-range-desc" class="f6 red db mb2 mt1">{{ error }}</small>
  </div>
</template>

<script>
import DateRangeSelect from '@/components/ui/DateRangeSelect.vue'

export default {
  props: ['value', 'title'],
  components: {
    DateRangeSelect
  },
  data () {
    return {
      error: null
    }
  },
  computed: {
    input: {
      get () {
        if (this.value?.input) {
          const { start, end } = this.value.input
          return { start: start, end: end }
        } else {
          return null
        }
      },
      set (value) {
        if (value) {
          const { start, end } = value
          this.fire({
            input: { start, end },
            valid: true
          })
        } else {
          this.fire({ input: null, valid: false })
        }
      }
    },
    empty () {
      return this.input == null
    }
  },
  methods: {
    fire ({ input, valid }) {
      this.error = valid ? null : 'Некорректный диапазон'
      this.$emit('input', { input: input, valid: valid })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
